// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oH-I","image":"Header_image__aT63g","name":"Header_name__14O6l","info":"Header_info__aeJhR","infoRow":"Header_infoRow__ND9Ol"};